__turbopack_context__.v({
  "actions": "THIQtq_actions",
  "box": "THIQtq_box",
  "dim": "THIQtq_dim",
  "discard": "THIQtq_discard",
  "draft": "THIQtq_draft",
  "land": "THIQtq_land",
  "landed": "THIQtq_landed",
  "layer": "THIQtq_layer",
  "lead": "THIQtq_lead",
  "lock": "THIQtq_lock",
  "more": "THIQtq_more",
  "moreButton": "THIQtq_moreButton",
  "muted": "THIQtq_muted",
  "own": "THIQtq_own",
  "placed": "THIQtq_placed",
  "save": "THIQtq_save",
});
